import { AttributeOptionEditorDialogParams } from './attribute-option-editor-dialog.component';
import { EventEmitter, Injectable } from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class AttributeOptionEditorDialogService {
  public requests = new EventEmitter<AttributeOptionEditorDialogParams>();
  constructor() { }
  Show(config:AttributeOptionEditorDialogParams): void {
    this.requests.emit(config);
  }
}
